(function(){
  'use strict';

  function money(cents){
    return (cents/100).toFixed(2).replace('.', ',') + ' MAD';
  }

  var toastEl = null;
  function toast(msg){
    if(!toastEl){
      toastEl = document.createElement('div');
      toastEl.className = 'vq-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    setTimeout(function(){ toastEl.classList.remove('show'); }, 2200);
  }

  /* ---------- Mobile menu ---------- */
  var burger = document.querySelector('[data-vq-burger]');
  var mnav = document.querySelector('.vq-mnav');
  if(burger && mnav){
    function setMobileNav(open){
      mnav.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    burger.setAttribute('aria-expanded', mnav.classList.contains('open') ? 'true' : 'false');
    burger.addEventListener('click', function(){ setMobileNav(!mnav.classList.contains('open')); });
    mnav.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){ setMobileNav(false); });
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') setMobileNav(false); });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('VqDrawer');
  var itemsBox = document.getElementById('VqDrawerItems');
  var totalBox = document.getElementById('VqDrawerTotal');

  function openDrawer(){ if(drawer){ drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }

  if(drawer){
    drawer.querySelectorAll('[data-vq-close]').forEach(function(el){ el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });
    var chk = document.getElementById('VqDrawerCheckout');
    if(chk){ chk.addEventListener('click', function(){ closeDrawer(); openCartCodModal(); }); }
  }

  /* ---------- Cart COD modal (replaces native Shopify checkout everywhere) ---------- */
  var cartCodModal = document.getElementById('VqCartCodModal');
  var cartCodList = document.getElementById('VqCartCodList');
  var cartCodProduitField = document.getElementById('VqCartCodProduit');

  function openCartCodModalRaw(){
    if(!cartCodModal) return;
    cartCodModal.classList.add('open');
    cartCodModal.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
  }

  function openCartCodModal(){
    if(!cartCodModal) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      if(!cart.items.length){ toast('Votre panier est vide'); return; }
      var lines = [];
      var html = '';
      cart.items.forEach(function(it){
        html += '<div class="vq-modal__cartitem"><span>' + it.product_title + ' × ' + it.quantity + '</span><span>' + money(it.final_line_price) + '</span></div>';
        lines.push(it.product_title + ' x' + it.quantity);
      });
      html += '<div class="vq-modal__carttotal"><span>Total</span><span>' + money(cart.total_price) + '</span></div>';
      if(cartCodList) cartCodList.innerHTML = html;
      if(cartCodProduitField) cartCodProduitField.value = lines.join(', ') + ' — Total: ' + money(cart.total_price);
      openCartCodModalRaw();
      var f = cartCodModal.querySelector('input:not([type=hidden])');
      if(f){ setTimeout(function(){ f.focus(); }, 350); }
    }).catch(function(){ toast('Erreur, r\u00e9essayez'); });
  }
  window.vqOpenCartCod = openCartCodModal;

  function closeCartCodModal(){
    if(!cartCodModal) return;
    cartCodModal.classList.remove('open');
    cartCodModal.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }
  if(cartCodModal){
    cartCodModal.querySelectorAll('[data-vq-cartcod-close]').forEach(function(el){ el.addEventListener('click', closeCartCodModal); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeCartCodModal(); });
  }
  var cartCodForm = document.getElementById('VqCartCodForm');
  if(cartCodForm){
    cartCodForm.addEventListener('submit', function(){
      var ph = cartCodForm.querySelector('[data-vq-cod-phone]');
      var em = cartCodForm.querySelector('[data-vq-cod-email]');
      if(ph && em){ var d = (ph.value||'').replace(/\D/g,''); em.value = (d||'commande') + '@vitarq.ma'; }
      var sb = cartCodForm.querySelector('[type=submit]');
      if(sb){ sb.disabled = true; sb.textContent = document.documentElement.lang === 'ar' ? 'جاري الإرسال…' : 'Envoi en cours…'; }
    });
    if(cartCodForm.querySelector('.vq-thankyou')){ openCartCodModalRaw(); }
  }

  /* Cart page → open cart COD modal instead of native checkout */
  var cartPageBtn = document.getElementById('VqCartPageCod');
  if(cartPageBtn){ cartPageBtn.addEventListener('click', openCartCodModal); }

  function updateCount(count){
    document.querySelectorAll('[data-vq-cart-count]').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCart(cart){
    updateCount(cart.item_count);
    if(!itemsBox) return;
    if(cart.item_count === 0){
      itemsBox.innerHTML = '<p class="vq-drawer__empty">Votre panier est vide.</p>';
      if(totalBox) totalBox.textContent = money(0);
      return;
    }
    var html = '';
    cart.items.forEach(function(it){
      var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x$1$2') : '';
      html += '<div class="vq-ditem" data-key="' + it.key + '">'
        + (img ? '<img src="' + img + '" alt="">' : '<div style="width:64px;height:64px;background:var(--vq-cream)"></div>')
        + '<div style="flex:1">'
        + '<div class="vq-ditem__t">' + it.product_title + '</div>'
        + '<div class="vq-ditem__p">' + money(it.final_line_price) + '</div>'
        + '<div class="vq-ditem__qty">'
        + '<button type="button" data-vq-qminus aria-label="Diminuer">−</button>'
        + '<span>' + it.quantity + '</span>'
        + '<button type="button" data-vq-qplus aria-label="Augmenter">+</button>'
        + '<button type="button" class="vq-ditem__rm" data-vq-remove>Supprimer</button>'
        + '</div></div></div>';
    });
    itemsBox.innerHTML = html;
    if(totalBox) totalBox.textContent = money(cart.total_price);

    itemsBox.querySelectorAll('.vq-ditem').forEach(function(row){
      var key = row.getAttribute('data-key');
      var item = cart.items.filter(function(i){ return i.key === key; })[0];
      if(!item) return;
      var minus = row.querySelector('[data-vq-qminus]');
      var plus = row.querySelector('[data-vq-qplus]');
      var rm = row.querySelector('[data-vq-remove]');
      if(minus) minus.addEventListener('click', function(){ changeQty(key, item.quantity - 1); });
      if(plus) plus.addEventListener('click', function(){ changeQty(key, item.quantity + 1); });
      if(rm) rm.addEventListener('click', function(){ changeQty(key, 0); });
    });
  }

  function fetchCart(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ renderCart(c); return c; });
  }

  function changeQty(key, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); }).then(renderCart).catch(function(){ toast('Erreur, r\u00e9essayez'); });
  }

  window.vqAddToCart = function(variantId, qty, openAfter){
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(function(r){
      if(!r.ok) throw new Error('add failed');
      return fetchCart();
    }).then(function(){
      if(openAfter !== false) openDrawer();
    }).catch(function(){ toast('Impossible d\u2019ajouter au panier'); });
  };

  /* Quick add buttons on cards */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-vq-quickadd]');
    if(!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-vq-quickadd');
    btn.disabled = true;
    window.vqAddToCart(vid, 1).then(function(){ btn.disabled = false; });
  });

  /* Cart icon opens drawer */
  document.addEventListener('click', function(e){
    var c = e.target.closest('[data-vq-open-cart]');
    if(!c) return;
    e.preventDefault();
    fetchCart().then(openDrawer);
  });

  /* ---------- Product form (legacy, kept for safety if present) ---------- */
  var pform = document.getElementById('VqProductForm');
  if(pform){
    var qtyInput = pform.querySelector('[name=quantity]');
    pform.querySelectorAll('[data-vq-step]').forEach(function(b){
      b.addEventListener('click', function(){
        var step = Number(b.getAttribute('data-vq-step'));
        var v = Math.max(1, (Number(qtyInput.value) || 1) + step);
        qtyInput.value = v;
      });
    });
    pform.addEventListener('submit', function(e){
      e.preventDefault();
      var vid = pform.querySelector('[name=id]').value;
      var q = Math.max(1, Number(qtyInput.value) || 1);
      var sb = pform.querySelector('[type=submit]');
      if(sb) sb.disabled = true;
      window.vqAddToCart(vid, q).then(function(){ if(sb) sb.disabled = false; });
    });
  }

  /* Collection sort */
  var sortSel = document.getElementById('VqSort');
  if(sortSel){
    sortSel.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }

  /* Cart page qty controls */
  document.querySelectorAll('[data-vq-cline]').forEach(function(row){
    var key = row.getAttribute('data-vq-cline');
    row.querySelectorAll('[data-vq-line-step]').forEach(function(b){
      b.addEventListener('click', function(){
        var cur = Number(row.getAttribute('data-vq-qty')) || 1;
        var next = Math.max(0, cur + Number(b.getAttribute('data-vq-line-step')));
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: next })
        }).then(function(){ window.location.reload(); });
      });
    });
    var rm = row.querySelector('[data-vq-line-remove]');
    if(rm){
      rm.addEventListener('click', function(){
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(){ window.location.reload(); });
      });
    }
  });

  /* Init cart count without competing with above-the-fold rendering. */
  function initCartCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ updateCount(c.item_count); }).catch(function(){});
  }
  if('requestIdleCallback' in window){ window.requestIdleCallback(initCartCount, { timeout: 1800 }); }
  else { window.setTimeout(initCartCount, 250); }
})();
(function(){
  var header = document.querySelector('.vq-header');
  var announce = document.querySelector('.vq-announce');

  function positionHeader(){
    if(!header) return;
    var isHome = document.body.classList.contains('template-index');
    if(isHome){
      var h = announce ? Math.ceil(announce.getBoundingClientRect().height) : 0;
      header.style.top = Math.max(0, h - 1) + 'px';
    } else {
      header.style.top = '';
    }
  }

  positionHeader();
  window.addEventListener('resize', positionHeader);
  window.addEventListener('load', positionHeader);
  setTimeout(positionHeader, 50);
  setTimeout(positionHeader, 300);

})();
